export enum PatientFactType {
  ANALYSES = 'Analyses',
  STATISTICS = 'Statistics',
}
